import { createContext } from 'react';

export type ToastTone = 'success' | 'info' | 'warning' | 'error';

export interface ToastOptions {
  durationMs?: number;
}

export interface ToastApi {
  show: (body: string, tone?: ToastTone, opts?: ToastOptions) => void;
  dismiss: (id: number) => void;
}

export const ToastContext = createContext<ToastApi | null>(null);
